module.exports = __webpack_public_path__ + "static/media/search.30fec061.svg";